/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type NsurePlanOverviewHorizon = (typeof NsurePlanOverviewHorizon)[keyof typeof NsurePlanOverviewHorizon];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NsurePlanOverviewHorizon = {
  past: "past",
  short: "short",
  middle: "middle",
  long: "long",
} as const;
